<script>
  import { createEventDispatcher } from 'svelte';
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ListGroup,
    ListGroupItem,
    Spinner,
  } from "sveltestrap";
  import axios from "axios";
  export let open;
  export let toggle;
  export let id;
  export let name;
  export let deliverable;
  export let floorStatus;
  let resource = null;
  let resource_id;
  let resourceAssigned = null;
  let busy = false;
  let focus = true;
  let debounceTimerId = 0;
  const onFocus = () => (focus = true);

  const dispatch = createEventDispatcher();

  function debounce(func) {
    clearTimeout(debounceTimerId);
    debounceTimerId = setTimeout(func, 300);
  }

  function addResource() {
    busy = true;
    axios
      .get(
        "/jobboardapi/AddFloorResource?name=" +
          name +
          "&deliverable=" +
          deliverable +
          "&floor=" +
          id +
          "&resource=" +
          resource_id +
          "&floorStatus=" +
          floorStatus
      )
      .then(function(response) {
        resource = "";
        dispatch('resourceassigned');
        toggle();
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(_ => busy = false);
  }

  function GetContact(resource) {
    axios
      .get(
        "/jobboardapi/GetContacts?name=" +
          resource +
          "&isTeamMember=" +
          false +
          "&team=" +
          ""
      )
      .then(function(response) {
        resourceAssigned = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function handleChangeResource(e) {
    resource = e.target.value;
    debounce(() => GetContact(resource));
  }

  function handlePassId(id, name) {
    focus = false;
    resource_id = id;
    resource = name;
  }
</script>

<style>
  .listgroup-style {
    overflow-y: scroll;
    max-height: 400px;
    position: absolute;
    border: 1px solid #4bcffa;
  }
  .listgroup-style::-webkit-scrollbar {
    display: none;
  }
  .listitem-style {
    width: auto;
    max-width: 465.5px;
    min-width: 465.5px;
  }
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Add Floor Resource</ModalHeader>
  <ModalBody>
    <input
      type="text"
      placeholder="Contacts"
      value={resource}
      on:keyup={handleChangeResource}
      on:focus={onFocus} />
    <input type="text" value={resource_id} hidden />
    {#if resourceAssigned !== null}
      {#if resource !== ''}
        {#if focus}
          <div class="listgroup-style">
            <ListGroup>
              {#each resourceAssigned as resource}
                <div class="listitem-style">
                  <ListGroupItem
                    tag="button"
                    action
                    key={resource.ContactId}
                    on:click={handlePassId(resource.ContactId, resource.FullName)}>
                    {resource.FullName}
                  </ListGroupItem>
                </div>
              {/each}
            </ListGroup>
          </div>
        {/if}
      {/if}
    {/if}
  </ModalBody>
  <ModalFooter>
    {#if busy}
      <Button color="primary" disabled style="cursor: not-allowed">
        <Spinner size="sm" />
      </Button>
    {:else}
      <Button color="primary" on:click={addResource}>Add</Button>
    {/if}
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
